export const DISCOUNT_TYPES = {
    PERCENT: 'PERCENT',
    SIMPLE: 'SIMPLE',
};
